<template>
  <span class="green-dot" />
</template>

<style lang="less" scoped>
.green-dot {
  display: inline-block;
  min-width: 10px;
  min-height: 10px;
  width: 10px;
  height: 10px;
  background: @basic-green;
  border-radius: 50%;
}
</style>
